import React from 'react';

import utils from './MoleculeCardUtils';
import Paper from 'material-ui/Paper';
import MoleculeCardTitle from './MoleculeCardTitle';
import MoleculeCardInfoBar from './MoleculeCardInfoBar';
import MoleculeCardTagBar from './MoleculeCardTagBar';
import MoleculeCardWeb from './MoleculeCardWeb';


export default class MoleculeThumb extends React.Component {

  render() {
    const {
      molecule, cardWidth, cardHeight, cardMargin, layout, onAction,
    } = this.props;
    const props = {
      molecule: molecule,
      layout: layout,
      onAction: (action) => {
        const hyphen = utils.hyphenToCamel('on-' + action.name);
        const handler = this.props[hyphen];
        if (handler) {
          handler(action);
        }
        if (onAction) {
          onAction(action);
        }
      }
    };
    // this is mainly for test purpose
    const zDepth = (layout === 'selected') ? 5 : 1
    // card size
    const cardStyle = {
      position: 'relative',
      overflow: 'hidden',
      background: layout === 'selected' ? '#e0e0e0' : '#fff',
      width: cardWidth,
      margin: cardMargin,
      height: cardHeight || 'auto',
      border: layout === 'selected' ? '5px solid #4D5E99' : '5px solid #fff',
    };
    return (
      <Paper
        zDepth={zDepth}
        className="dash-card"
        style={cardStyle}
        onTouchTap={e => {
          // must prevent event from emit to parent
          // so parent can hook on his events ONLY
          e.stopPropagation();
          e.preventDefault();
          e.nativeEvent.stopImmediatePropagation();
        }}
      >
        <MoleculeCardWeb {...props} />
        <MoleculeCardTitle {...props} />
        <MoleculeCardInfoBar {...props} />
        <MoleculeCardTagBar {...props} />
      </Paper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/MoleculeCard/MoleculeCard.jsx